import { render, staticRenderFns } from "./QrCard.vue?vue&type=template&id=f5276296&scoped=true"
import script from "./QrCard.vue?vue&type=script&lang=js"
export * from "./QrCard.vue?vue&type=script&lang=js"
import style0 from "./QrCard.vue?vue&type=style&index=0&id=f5276296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5276296",
  null
  
)

export default component.exports